import React, { useRef, useState, useEffect } from "react";
import { EditProfileImage } from "../../../components/superadmin";
import { TbTrashX } from "react-icons/tb";
import { BiCloudUpload } from "react-icons/bi";
import { useFormik } from "formik";
import * as Yup from "yup";
import { handleApi } from "../../../utils/authentication";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import Select from "react-select";
import { useParams } from "react-router-dom";
import user_default from "../../../assests/user_default.png";
import LoadingSpinner from "../../../components/client/LoadingSpinner";
import { addMemberSteps } from "../client-tour/add_member";
import useClientTour from "../../../hooks/useClientTour";

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    minHeight: "44px", // minimum height of the control
    height: "44px", // fixed height
    fontSize: "14px", // adjust font size if needed
    fontFamily: "aeonik_medium", // customize font family
    border: state.isFocused ? "1px solid #007bff" : "1px solid #ced4da", // border style
    boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(0,123,255,.25)" : null,
    borderRadius: "8px",
  }),
  valueContainer: (provided) => ({
    ...provided,
    height: "44px",
    minHeight: "44px",

    overflowY: "auto",
    "::-webkit-scrollbar": {
      display: "none",
    },
    "-ms-overflow-style": "none" /* IE and Edge */,
    "scrollbar-width": "none",

    padding: "0 8px", // adjust padding to align text
    display: "flex",
    alignItems: "center",
  }),
  input: (provided) => ({
    ...provided,
    margin: "0",
    padding: "0",
    height: "44px",
  }),
  singleValue: (provided) => ({
    ...provided,
    lineHeight: "44px",
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: "44px",
  }),
  indicatorSeparator: () => ({
    display: "none", // remove the default indicator separator
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    padding: "4px",
    color: "#7F56D9",
  }),
  menuList: (provided) => ({
    ...provided,
    "::-webkit-scrollbar": {
      display: "none",
    },
    "-ms-overflow-style": "none" /* IE and Edge */,
    "scrollbar-width": "none" /* Firefox */,
  }),
};

const CreateUser = () => {
  const profileImageRef = useRef(null);
  const [imageUri, setImageUri] = useState("");
  const [show, setShow] = useState(false);
  const [file, setFile] = useState(null);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(false);
  const user = useSelector((state) => state?.user);
  const tour = useSelector((state) => state?.tour);

  const { user_id } = useParams();

  useClientTour({
    enabled: !user?.has_seen_tour && !tour?.add_member_page && user?.is_client,
    steps: addMemberSteps,
    tourKey: "add_member_page",
    nextRoute: "/client/settings/integrations",
    skipRoute: "/client/settings/add_user",
  });

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (!file.type.startsWith("image/")) {
        toast.error("Only image files are allowed!");
        event.target.value = ""; // clear invalid file
        return;
      }

      const reader = new FileReader();
      reader.onloadend = () => {
        setImageUri(reader.result);
        setShow(true);
      };
      reader.readAsDataURL(file);
      setFile(file);
    }
    event.target.value = "";
  };
  const roles = [
    { value: 1, label: "Admin" },
    // {value:2,label:"Owner"},
    { value: 3, label: "Member" },
    // {value:4,label:"Viewer"}
  ];
  //update user
  const handleUpdateUser = async () => {
    try {
      setLoading(true); // Start loading
      let method = "POST";
      let headers = {};
      let formData = new FormData();
      if (imageUri && file) {
        let response = await fetch(imageUri);
        let image_file = await response?.blob();
        formData.append("profile_image", image_file, file?.name);
      }

      formData.append("first_name", formik.values.first_name);
      formData.append("last_name", formik.values.last_name);
      formData.append("email", formik.values.email);
      formData.append("role_id", formik.values.role?.value);
      formData.append("user_id", user_id);
      formData.append("client_id", user?.client_id);
      formData.append("status", formik.values.status?.value);

      let result = await handleApi("edit_user", method, headers, formData);

      if (result?.success) {
        toast.success("User details updated Successfully.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        navigate("/client/settings/users");
      } else {
        toast.error(
          result?.error?.error_message
            ? result?.error?.error_message
            : "Something went wrong! Please Try again later",
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          },
        );
      }
    } catch (e) {
      toast.error(e.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } finally {
      setLoading(false); // Stop loading
    }
  };
  //create user
  const handleCreateUser = async () => {
    try {
      setLoading(true); // Start loading
      let method = "POST";
      let headers = {};
      let formData = new FormData();
      if (imageUri && file) {
        let response = await fetch(imageUri);
        let image_file = await response?.blob();
        formData.append("profile_image", image_file, file?.name);
      }

      formData.append("first_name", formik.values.first_name);
      formData.append("last_name", formik.values.last_name);
      formData.append("email", formik.values.email);
      formData.append("role_id", formik.values.role?.value);
      formData.append("client_id", user?.client_id);
      formData.append(
        "user_setup_password_link_prefix",
        process.env.REACT_APP_URL + "client/setup_password/",
      );

      let result = await handleApi(
        "create_user_for_client",
        method,
        headers,
        formData,
      );

      if (result?.success) {
        toast.success("User Created Successfully.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        navigate("/client/settings/users");
      } else {
        toast.error(
          result?.error?.error_message
            ? result?.error?.error_message
            : "Something went wrong! Please Try again later",
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          },
        );
      }
    } catch (e) {
      toast.error(e.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } finally {
      setLoading(false); // Stop loading
    }
  };

  //get user details
  const getUserDetails = async () => {
    try {
      setInitialLoading(true);
      if (user_id) {
        let method = "POST";
        let headers = {};
        let formdata = new FormData();
        formdata.append("user_id", user_id);
        let result = await handleApi(`view_user`, method, headers, formdata);
        if (result?.success) {
          formik.setValues({
            first_name: result?.data?.user_info?.first_name,
            last_name: result?.data?.user_info?.last_name,
            email: result?.data?.user_info?.email,
            role: {
              value: result?.data?.user_info?.role_id,
              label: result?.data?.user_info?.role_name,
            },
            status: {
              value: result?.data?.user_info?.status,
              label: result?.data?.user_info?.status ? "Active" : "block",
            },
          });

          if (result?.data?.user_info?.profile_image) {
            setImageUri(result?.data?.user_info?.profile_image);
          }
        } else {
          toast.error("Failed to load customer details", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          return;
        }
      }
    } catch (e) {
      console.log(e);
    } finally {
      setInitialLoading(false);
    }
  };
  const validationSchema = Yup.object({
    first_name: Yup.string()
      .required("Firstname is Required")
      .matches(/^[A-Za-z]+$/, "Only letters are allowed"),
    last_name: Yup.string()
      .required("Lastname is Required")
      .matches(/^[A-Za-z]+$/, "Only letters are allowed"),
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is Required"),
    role: Yup.object().required("Role is Required"),
  });

  const formik = useFormik({
    initialValues: {
      first_name: "",
      last_name: "",
      email: "",
      role: "",
      status: 1,
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      if (user_id) {
        handleUpdateUser();
      } else {
        handleCreateUser();
      }
    },
  });

  useEffect(() => {
    if (user_id) {
      getUserDetails();
    }
  }, []);


  return (
    <div>
      <form onSubmit={formik.handleSubmit}>
        <div className="w-100 h-100 position-relative d-flex flex-column align-items-center mb-2 add-member-form">
          {initialLoading && <LoadingSpinner />}
          <EditProfileImage
            show={show}
            setShow={setShow}
            uri={imageUri}
            setImageUri={setImageUri}
            aspect_ratio={1}
          />
          <div className="card profile_card px-3 my-2 ">
            <div>
              <h5 className="pb-0"> {!user_id ? "Add" : "Edit"} Member </h5>
            </div>
            <div className="row border-1 border-bottom pb-4 upload-profile-image">
              <div className="col-xl-2 d-flex justify-content-center justify-content-xl-start  ">
                <img src={imageUri ? imageUri : user_default} alt="Profile" />
                <input
                  ref={profileImageRef}
                  type="file"
                  id="profile_image"
                  className="d-none"
                  accept="image/*"
                  onChange={handleImageUpload}
                />
              </div>
              <div className="col-xl-6 row d-flex align-items-end">
                <div className="col-12 col-md-12 col-lg-6 mb-2">
                  <button
                    type="button"
                    onClick={() => {
                      setImageUri("");
                    }}
                    className={`w-100 ${!imageUri && "disable_btn"} btn btn-outline-custom btn-outline-primary rounded-pill d-flex justify-content-center align-items-center gap-1`}
                    disabled={!imageUri}
                  >
                    <TbTrashX /> Delete Profile Image
                  </button>
                </div>
                <div className="col-12 col-md-12 col-lg-6 mb-2">
                  <button
                    type="button"
                    onClick={() => {
                      profileImageRef.current.click();
                    }}
                    className="w-100 py-2 btn btn-primary rounded-pill d-flex justify-content-center align-items-center gap-1"
                  >
                    <BiCloudUpload /> Upload Profile Image
                  </button>
                </div>
              </div>
            </div>

            <div className="mb-1 row input-first-name">
              <label htmlFor="first_name" className="col-lg-2 col-form-label">
                First Name *
              </label>
              <div className="col-lg-6">
                <input
                  type="text"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.first_name}
                  className="form-control"
                  id="first_name"
                  placeholder="Enter Firstname"
                />
                {formik.touched.first_name && formik.errors.first_name ? (
                  <div className="text-danger text-start small">
                    {formik.errors.first_name}
                  </div>
                ) : null}
              </div>
            </div>
            <div className="mb-1 row input-last-name">
              <label htmlFor="last_name" className="col-lg-2 col-form-label">
                Last Name *
              </label>
              <div className="col-lg-6">
                <input
                  type="text"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.last_name}
                  className="form-control"
                  id="last_name"
                  pattern="^[A-Za-z]+$"
                  title="Only letters are allowed"
                  placeholder="Enter Lastname"
                />
                {formik.touched.last_name && formik.errors.last_name ? (
                  <div className="text-danger text-start small">
                    {formik.errors.last_name}
                  </div>
                ) : null}
              </div>
            </div>
            <div className="mb-1 row input-email">
              <label htmlFor="email" className="col-lg-2 col-form-label">
                Email *
              </label>
              <div className="col-lg-6">
                <input
                  type="text"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.email}
                  className="form-control"
                  id="email"
                  placeholder="Enter Email"
                  disabled={user_id ? true : false}
                />
                {formik.touched.email && formik.errors.email ? (
                  <div className="text-danger text-start small">
                    {formik.errors.email}
                  </div>
                ) : null}
              </div>
            </div>
            <div className="mb-1 row select-role">
              <label htmlFor="role" className="col-lg-2 col-form-label">
                Role *
              </label>
              <div className="col-lg-6">
                <Select
                  id="role"
                  name="role"
                  placeholder="Select Role"
                  styles={customStyles}
                  value={formik.values.role}
                  options={roles}
                  onChange={(selected_options) => {
                    formik.setFieldValue("role", selected_options);
                  }}
                />
                {formik.touched.role && formik.errors.role ? (
                  <div className="text-danger text-start small">
                    {formik.errors.role}
                  </div>
                ) : null}
              </div>
            </div>
            {user_id && (
              <div className="mb-1 row">
                <label htmlFor="role" className="col-lg-2 col-form-label">
                  User Status *
                </label>
                <div className="col-lg-6">
                  <Select
                    id="status"
                    name="status"
                    placeholder="Select Status"
                    styles={customStyles}
                    value={formik.values.status}
                    options={[
                      { label: "Active", value: 1 },
                      { label: "Block", value: 0 },
                    ]}
                    onChange={(selected_options) => {
                      formik.setFieldValue("status", selected_options);
                    }}
                  />
                  {formik.touched.role && formik.errors.role ? (
                    <div className="text-danger text-start small">
                      {formik.errors.role}
                    </div>
                  ) : null}
                </div>
              </div>
            )}
            {(user?.role_id === 1 || user?.role_id === 2) && (
              <div className="mb-1 row mt-2  row ">
                <div className="col-lg-8 d-flex justify-content-end">
                  {loading ? (
                    <button
                      type="button"
                      className="btn btn-primary rounded-pill px-5 btn-submit-member"
                      disabled
                    >
                      Saving...
                    </button>
                  ) : (
                    <button
                      type="submit"
                      className="btn btn-primary rounded-pill px-5 btn-submit-member"
                    >
                      Save
                    </button>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </form>
    </div>
  );
};

export default CreateUser;
